/* eslint @stylistic/key-spacing: ["error", {  "align": "value" }]*/

const APPLICATION_TYPE = {
    NEW_TICKET:                           'NEW_TICKET',
    UPDATE_CUSTOMER:                      'UPDATE_CUSTOMER',
    UPDATE_TICKETHOLDER:                  'UPDATE_TICKETHOLDER',
    UPDATE_BANKACCOUNTHOLDER:             'UPDATE_BANKACCOUNTHOLDER',
    TICKET_EXCHANGE:                      'TICKET_EXCHANGE',
    TICKET_REPLACEMENT:                   'TICKET_REPLACEMENT',
    TICKET_TERMINATION:                   'TICKET_TERMINATION',
    GET_ACCESS:                           'GET_ACCESS',
    ASSIGNMENT_USER:                      'ASSIGNMENT_USER',
    DIRECT_SALE:                          'DIRECT_SALE',
    DOCUMENT_TICKETHOLDER:                'DOCUMENT_TICKETHOLDER',
    TICKET_TERMINATION_ANONYMOUS:         'TICKET_TERMINATION_ANONYMOUS',
    TICKET_PROOF:                         'TICKET_PROOF',
    TICKET_REFUND:                        'TICKET_REFUND',
    TICKETHOLDER_SCHEDULED_SCHOOL_CHANGE: 'TICKETHOLDER_SCHEDULED_SCHOOL_CHANGE'

}
export default APPLICATION_TYPE